export default "__VITE_ASSET__CiCYkibV__"